import { html, nothing, type TemplateResult } from 'lit';

import type { ChatStatus } from '../ai-chat-messages';

export function renderAssistantIdentity(
  status: ChatStatus = 'idle',
  detail: TemplateResult | typeof nothing = nothing
) {
  return html`<div class="user-info">
    <chat-assistant-avatar .status=${status}></chat-assistant-avatar>
    ${detail}
  </div>`;
}
